import React, { useCallback, useState } from "react";

import { MoreIcon as More } from "@packages/ds";
import { useIntl } from "react-intl";

import { ProcessSignalNumber } from "Api/adminAgent/types/ProcessSignal.enum";
import { ServiceProcess } from "Api/adminAgent/types/ServiceProcess.type";
import * as Dropdown from "ds/Dropdown";
import { copyToClipboard } from "Libs/utils";
import { useOpenProcessActionModal } from "Reducers/serviceProcesses/hooks/useOpenProcessActionModal";

import { AdvancedOptionsDialog } from "./AdvancedOptionsDialog";
import * as S from "./OptionsButton.styles";

export type OptionsButtonProps = {
  process: ServiceProcess;
  setCurrentOpen: (open: boolean) => void;
};

export const OptionsButton = ({
  setCurrentOpen,
  process
}: OptionsButtonProps) => {
  const { formatMessage } = useIntl();
  const openProcessActionModal = useOpenProcessActionModal();
  const [open, setOpen] = useState(false);

  const onOpenChange = (_open: boolean) => {
    setOpen(_open);
    setCurrentOpen(_open);
  };
  const onCopyClick = useCallback(async () => {
    copyToClipboard(String(process.pid));
  }, [process.pid]);

  return (
    <Dropdown.Root
      open={open}
      onOpenChange={onOpenChange}
      id="services.process.options"
    >
      <Dropdown.Trigger>
        <More />
      </Dropdown.Trigger>

      <S.CustomContent>
        <Dropdown.Item onClick={onCopyClick}>
          {formatMessage({ id: "services.process.options.copy" })}
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() =>
            openProcessActionModal(process, ProcessSignalNumber.SIGKILL)
          }
        >
          {formatMessage({ id: "services.process.options.force_kill" })}
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() =>
            openProcessActionModal(process, ProcessSignalNumber.SIGTERM)
          }
        >
          {formatMessage({
            id: "services.process.options.terminate_process"
          })}
        </Dropdown.Item>

        <S.CustomSeparator />

        <AdvancedOptionsDialog
          process={process}
          onClick={() => setOpen(false)}
        />
      </S.CustomContent>
    </Dropdown.Root>
  );
};
